import { dateFormatterPattern } from 'core/service/lib/date'

// eslint-disable-next-line import/no-named-as-default
import Date from '../../../../common-components/date'

export const Component = Date

const HookComponent = (hoc) => {
  const WrappedInput = hoc ? hoc(Date) : Date
  return function(props) {
    const {
      setValue,
      dispatch,
      onChange = () => {},
      value,
      validate,
      className = 'form-control',
      type = 'tel',
      pattern = dateFormatterPattern,
    } = props
    const _onChange = (e) => {
      setValue(e.target.value)
      onChange({ dispatch, value: e.target.value })
    }
    const handleFocus = () => {
      if (validate) validate(false)
    }

    const handleBlur = () => {
      if (validate) validate(true)
    }
    return (
      <WrappedInput
        {...props}
        className={className}
        type={type}
        pattern={pattern}
        value={value}
        onChange={_onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    )
  }
}

export default HookComponent
